import Stack from '@mui/material/Stack'

interface CircleProps {
  size: number
  borderColor: string
}

export const Circle: React.FC<React.PropsWithChildren<CircleProps>> = ({
  children,
  size,
  borderColor,
}) => (
  <Stack
    sx={{
      alignItems: 'center',
      border: '1px solid',
      borderColor,
      borderRadius: '50%',
      height: size,
      justifyContent: 'center',
      position: 'relative',
      width: size,
    }}
  >
    {children}
  </Stack>
)
